export default "__VITE_ASSET__BQw7IQc___"